import { FC, PropsWithChildren, useState } from 'react';
import { TakeoverContext, TakeoverMetadata } from './TakeoverContext';

export const TakeoverContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [metadata, setMetadata] = useState<TakeoverMetadata>();

  const openTakeover = (metadata?: TakeoverMetadata) => {
    setIsOpen(true);
    setMetadata(metadata);
  };

  const closeTakeover = () => {
    setIsOpen(false);
  };

  const value = { closeTakeover, isOpen, metadata, openTakeover };

  return <TakeoverContext.Provider value={value}>{children}</TakeoverContext.Provider>;
};
